import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  canonicalUrlOrigin: "https://developer.itspaydai.com",

  sitemap: {
    siteUrl: "https://developer.itspaydai.com",
  },

  site: {
    title: "PayDai",
    logo: {
      src: {
        light: "/logo.png",
        dark: "/logo.png",
      },
      alt: "PayDai",
      width: "32px",
    },
  },

  metadata: {
    title: "PayDai | Developer Portal",
    description:
      "Build on PayDai  -  automate lead capture, commissions, and payouts.",
    favicon: "/favicon.png",
  },

  // Paydai brand: primary purple #A283DB, dark bg #0D0814
  theme: {
    dark: {
      background: "#0D0814",
      foreground: "#f0ebfa",
      card: "#140d21",
      cardForeground: "#f0ebfa",
      popover: "#140d21",
      popoverForeground: "#f0ebfa",
      primary: "#A283DB",
      primaryForeground: "#ffffff",
      secondary: "#1f1335",
      secondaryForeground: "#f0ebfa",
      muted: "#1f1335",
      mutedForeground: "#9b8db3",
      accent: "#2d1b4e",
      accentForeground: "#f0ebfa",
      destructive: "#ef4444",
      destructiveForeground: "#ffffff",
      border: "#2d1b4e",
      input: "#2d1b4e",
      ring: "#A283DB",
      radius: "0.5rem",
    },
    light: {
      background: "#ffffff",
      foreground: "#1a0f2e",
      card: "#faf9ff",
      cardForeground: "#1a0f2e",
      popover: "#ffffff",
      popoverForeground: "#1a0f2e",
      primary: "#7F5FB1",
      primaryForeground: "#ffffff",
      secondary: "#f3f0ff",
      secondaryForeground: "#1a0f2e",
      muted: "#f3f0ff",
      mutedForeground: "#6b5c8a",
      accent: "#ede9fe",
      accentForeground: "#1a0f2e",
      destructive: "#ef4444",
      destructiveForeground: "#ffffff",
      border: "#e4dff5",
      input: "#e4dff5",
      ring: "#7F5FB1",
      radius: "0.5rem",
    },
  },

  navigation: [
    {
      type: "category",
      label: "Get Started",
      icon: "rocket",
      items: [
        { type: "doc", file: "introduction", label: "Introduction" },
        { type: "doc", file: "quickstart", label: "Quickstart" },
        { type: "doc", file: "authentication", label: "Authentication" },
      ],
    },
    {
      type: "category",
      label: "Webhooks",
      icon: "webhook",
      items: [
        { type: "doc", file: "webhooks/overview", label: "Overview" },
        { type: "doc", file: "webhooks/managing-endpoints", label: "Managing endpoints" },
        { type: "doc", file: "webhooks/event-types", label: "Event types" },
        {
          type: "category",
          label: "Payload reference",
          icon: "file-text",
          items: [
            { type: "doc", file: "webhooks/payloads/sale", label: "Sale" },
            { type: "doc", file: "webhooks/payloads/commission", label: "Commission" },
            { type: "doc", file: "webhooks/payloads/member", label: "Member" },
            { type: "doc", file: "webhooks/payloads/member-commission-plan", label: "Member Commission Plan" },
            { type: "doc", file: "webhooks/payloads/lead", label: "Lead" },
            { type: "doc", file: "webhooks/payloads/product", label: "Product" },
            { type: "doc", file: "webhooks/payloads/refund", label: "Refund" },
            { type: "doc", file: "webhooks/payloads/processor", label: "Processor" },
          ],
        },
        { type: "doc", file: "webhooks/nested-objects", label: "Nested objects" },
      ],
    },
    {
      type: "link",
      label: "API Reference",
      to: "/api",
      icon: "code",
    },
    {
      type: "link",
      label: "Support",
      to: "mailto:support@itspaydai.com",
      icon: "mail",
      target: "_blank",
    },
  ],

  redirects: [{ from: "/", to: "/introduction" }],

  apis: {
    type: "file",
    input: "./openapi.yaml",
    path: "/api",
    options: {
      disableSecurity: false,
      examplesLanguage: "shell",
      supportedLanguages: [
        { value: "shell", label: "cURL" },
        { value: "javascript", label: "JavaScript" },
        { value: "python", label: "Python" },
      ],
      schemaDownload: {
        enabled: true,
      },
    },
  },

  docs: {
    files: "/pages/**/*.{md,mdx}",
  },
};

export default config;
